import { useCallback } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { FormProps } from "react-final-form";
import { useErrorFormatter } from "shared/utils";
import { RegainReportRequest } from "api/models";
import { useSelectedShop } from "shared/hooks";
import { NetworkError } from "shared/types";
import { postRegainReport } from "../api";
import { RegainReportFormData } from "../types";

export const useRegainsReport = (
  queryKey: (string | number | undefined)[],
  regainIds: string[],
  onSubmit: () => void
) => {
  const { selectedShopId } = useSelectedShop();

  const queryClient = useQueryClient();

  const formatError = useErrorFormatter();

  const { mutateAsync: reportRegains } = useMutation<
    void,
    AxiosError<{ message: string }>,
    RegainReportRequest
  >(postRegainReport);

  const executeRegainsReport: FormProps<RegainReportFormData, RegainReportFormData>["onSubmit"] =
    useCallback(
      async ({ reportComment }) => {
        try {
          await reportRegains({
            regainIds,
            reportComment,
            shopId: selectedShopId!
          });

          onSubmit();

          await queryClient.invalidateQueries(queryKey);
        } catch (error) {
          return formatError(error as NetworkError);
        }
      },
      [selectedShopId, queryKey, reportRegains, regainIds, onSubmit]
    );

  return executeRegainsReport;
};
